import type { CnstrcContentSlot } from '@/js/services/cnstrc/types'

export const widgets = {
  CATEGORY         : 'rfkid_10',
  RSS              : 'rfkid_32',
  CART             : 'rfkid_4',
  SEARCH_PREVIEW   : 'rfkid_6',
  SEARCH_RESULTS   : 'rfkid_7',
  SEARCH_EMPTY     : 'rfkid_a1',
  PRODUCTS_SIMILAR : 'rfkid_31',
  PRODUCTS_FOR_YOU : 'rfkid_32',
  HOME             : 'rfkid_1',
}

export const DEFAULTS = {
  N_ITEM: 80,
}

export const PRODUCT_FIELD_VALUES = [
  'url',
  'sku',
  'image_url',
  'manufacturer',
  'entity_id',
  'price',
  'final_price',
  'name',
  'cat1',
  'cat2',
  'cat3',
  'special_price',
  'thumbnail',
  'rogue_rfk_custom_data',
  'rogue_hover_image',
  'tax_class_id',
  'type',
  'challenge_status',
]

export interface IReflektionFacetValue {
  count: number;
  id: string;
  text: string;
  urlKey: string;

  // This is set by category.vue
  categoryRoute?: string;
  label: string;
  active?: boolean;
  route?: { query: any }
}

export interface IReflektionFacet {
  display_name: string;
  number_of_products: number;
  key: string;
  total: number;
  value: IReflektionFacetValue[]
}

export type IReflektionRawProduct = {
  cat1: string,
  cat2?: string,
  cat3?: string,
  challenge_status?: string,
  type: string,
  manufacturer?: string[],
  entity_id: string
  final_price?: string
  image_url: string
  name: string
  price: string
  tax_class_id?: string
  rogue_rfk_custom_data?: string
  rogue_hover_image?: string
  sku: string
  thumbnail: string
  url: string
}

export type IReflektionRelatedProduct = {
  productId: number,
  childId?: number,
  variationKey?: string,
  related: string,
  color?: string,
  thumbnail: string,
  altImage?: string,
  url?: string,
  name: string,
  price?: number,
  special_price?: number,
}

export type IReflektionProcessedProduct = {
  relatedLabelName?: string
  productId: number,
  variationKey?: string,
  thumbnail: string,
  price: number,
  quoted?: boolean
  attributes: { tax_class_id?: string, manufacturer?: string },
  related?: IReflektionRelatedProduct[]
  brand?: string,
  categories: string[],
  altImage?: string,
  special_price?: number,
  name: string,
  challenge_status?: string,
  type: string,
  url: string,
  sku: string,
  hasRedirect?: boolean,
  hidePrice?: boolean,
  ratingCount?: number,
  ratingAverage?: number,
}

type IReflektionResponse = {
  autocomplete?: string
  facet: { [key: string]: IReflektionFacet };
  facet_names: string[];
  n_item: number;
  page_number: number;
  total_item: number;
  total_page: number;
  url: string;
  errors?: { error: string, type: string }[]
  redirect_url?: string
  suggestion?: {
    category: { url: string, text: string, freq: number, id: string }[],
    keyphrase: { text: string, freq: number, id: string }[],
    trending_category: { url: string, text: string, id: string }[]
  }
  widget: {
    rfkid: string;
  };
  sort_options?: { sort_by: string; display_name: string; sort_order: string; status: string }[]
  cnstrc_content?: CnstrcContentSlot[]
}

export type IReflektionRawResponse = IReflektionResponse & {
  content: { product: { n_item: number, total_item: number, value: IReflektionRawProduct[] } };
}

export type IReflektionProcessedResponse = IReflektionResponse & {
  content: { product: { n_item: number, total_item: number, value: IReflektionProcessedProduct[] } };
}

export interface IReflektionPayloadFilter {
  [key: string]: { value: string[], }
}

export interface IReflektionPayloadSort {
  value: { type: string, order: string }[]
}

export interface IReflektionPayloadOptions {
  widget: string;
  uri: string;
  n_item?: number;
  page_number?: number | string;
  query?: string;
  filter?: IReflektionPayloadFilter;
  sort?: IReflektionPayloadSort;
}

export interface IReflektionPayloadQuery {
  keyphrase: {
    value: string[]
  }
}

export interface IReflektionRequestPayload {
  n_item: number;
  page_number: number;

  content: {
    // Which fields we want to return
    product: { field: { value: string[] } }
  };

  context: {
    page: { uri: string },
    user: { user_id: string | number }
  };

  query?: IReflektionPayloadQuery;
  widget: { rfkid: string };
  facet: { total: boolean, all: boolean, max: number };
  filter?: IReflektionPayloadFilter;
  sort?: IReflektionPayloadSort;

  // For Preview Search
  suggestion?: {
    trending_category: { max: number },
    category: { max: number },
    keyphrase: { max: number }
  }
}
